import { context } from "../../wr-context";
import { makeAction, WorkflowUnit } from "./../workflow";
import { isPathMatch } from "./utils";
var PRODUCT_SELECTION_KEY = "productSelection";
export var redirectToIndex = makeAction("redirectToIndex", function() {
    context.history.push(context.getRoutePath("index"));
}, function() {
    return isPathMatch("index");
});
export var redirectToProductDetails = makeAction("redirectToProductDetails", function() {}, function() {
    return isPathMatch("productDetail");
});
export var defaultActions = [
    redirectToIndex,
    redirectToProductDetails
];
export var createProductSelectionUnit = function(options) {
    var ref;
    var productSelectionActions = (ref = options === null || options === void 0 ? void 0 : options.actions) !== null && ref !== void 0 ? ref : defaultActions;
    return new WorkflowUnit(PRODUCT_SELECTION_KEY, productSelectionActions);
};
var ProductSelectionUnit = createProductSelectionUnit();
export default ProductSelectionUnit;
